import { Link } from "react-router-dom";
import { serviceAreas } from "../../../mocks/services";

export default function ServiceAreasSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Coverage</p>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Barlow', sans-serif" }}>
            Serving Your Local Area
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Jerry&apos;s Plumbing, Heating &amp; Welding provides fast, reliable plumbing and heating services for homeowners and businesses across the entire DFW metroplex.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden h-[460px] border border-gray-100">
            <iframe
              title="Jerry's Plumbing & Heating — 440 Whitney St, Cedar Hill TX"
              src="https://maps.google.com/maps?q=440+Whitney+St,+Cedar+Hill,+TX+75104&t=&z=12&ie=UTF8&iwloc=&output=embed"
              className="w-full h-full border-0"
              loading="lazy"
              aria-label="Map showing Jerry's Plumbing & Heating location in Cedar Hill TX"
            />
          </div>

          {/* Info + Areas */}
          <div className="flex flex-col gap-5">
            {/* Contact info card */}
            <div className="bg-[#0B1829] rounded-2xl p-7 text-white">
              <h3 className="font-black text-xl mb-4" style={{ fontFamily: "'Barlow', sans-serif" }}>
                Our Location &amp; Contact
              </h3>
              <div className="space-y-3.5 mb-5">
                <div className="flex items-start gap-3 text-gray-300 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-fill text-[#E8500A]" />
                  </span>
                  440 Whitney St, Cedar Hill, TX 75104
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-[#E8500A]" />
                  </span>
                  <a href="tel:8178324968" className="text-gray-300 hover:text-white transition-colors">
                    Arlington: <strong className="text-white">(817) 832-4968</strong>
                  </a>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-[#E8500A]" />
                  </span>
                  <a href="tel:9722625113" className="text-gray-300 hover:text-white transition-colors">
                    Dallas: <strong className="text-white">(972) 262-5113</strong>
                  </a>
                </div>
                <div className="flex items-center gap-3 text-gray-300 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-fill text-[#E8500A]" />
                  </span>
                  <strong className="text-white">24/7 Emergency Service Available</strong>
                </div>
              </div>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://maps.app.goo.gl/oqw8JCNvgSRZngpEA"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-4 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap"
                >
                  <i className="ri-road-map-line" /> Get Directions
                </a>
                <Link to="/location" className="flex items-center gap-2 border border-white/25 hover:border-white text-white font-semibold px-4 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap">
                  View All Areas
                </Link>
              </div>
            </div>

            {/* Cities grid */}
            <div className="bg-[#F8F7F4] rounded-2xl p-7 flex-1">
              <h3 className="font-black text-lg text-gray-900 mb-4" style={{ fontFamily: "'Barlow', sans-serif" }}>
                DFW Communities We Serve
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {serviceAreas.map((area) => (
                  <div key={area} className="flex items-center gap-1.5 text-gray-700 text-sm py-1">
                    <i className="ri-map-pin-fill text-[#E8500A] text-xs flex-shrink-0" />
                    {area}
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-gray-400 text-xs">
                  Don&apos;t see your city? Call us — we likely serve your area.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
